import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const DialogTrigger = (props: ComponentProps<typeof DialogPrimitive.Trigger>) => (
  <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />
);
